import { render, staticRenderFns } from "./CWBGWHLE.vue?vue&type=template&id=15c997fd&scoped=true"
import script from "./CWBGWHLE.vue?vue&type=script&lang=js"
export * from "./CWBGWHLE.vue?vue&type=script&lang=js"
import style0 from "./CWBGWHLE.vue?vue&type=style&index=0&id=15c997fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c997fd",
  null
  
)

export default component.exports